import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet';
import SignupForm from './utils/SignupForm';
import { Link } from 'react-router-dom';
import HealthSection from './utils/HealthSection';

const Physiotherapyformortonsneuroma = () => {
    return (
        <div>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Effective Physiotherapy for Morton's Neuroma</h1>
                    <h2>Explore specialized physiotherapy solutions for Morton's Neuroma at Ramp Physio and Fitness, where our tailored treatments help alleviate pain and improve foot function.</h2>
                    <p>Morton's Neuroma can be a source of persistent foot pain, affecting your mobility and quality of life. At Ramp Physio and Fitness, we provide expert physiotherapy services to address this condition, combining evidence-based techniques and personalized care to help you walk comfortably again. In this article, we'll discuss the benefits of physiotherapy for Morton's Neuroma and how our approach can help you get back on your feet.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Understanding Morton's Neuroma</h1>
                        <p>Morton's Neuroma involves a thickening of the tissue around the nerves leading to your toes, often causing pain in the ball of your foot. Symptoms may include burning sensations, numbness, and discomfort when walking. Physiotherapy interventions can be highly effective in managing these symptoms, allowing for improved foot mechanics and relief from pain.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            </SkewedContainer>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Customized Treatment Plans</h1>
                    <p>Each case of Morton's Neuroma is unique, and so are our treatment plans. Our physiotherapists at Ramp Physio and Fitness take a patient-centered approach to address individual needs. From manual therapies to exercise prescriptions, we design a program that targets the root cause of your symptoms, promoting long-term foot health.</p>
                </div>
            </div>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Non-Surgical Approaches</h1>
                    <p>Nonsurgical interventions are often the first line of treatment for Morton's Neuroma. Our physiotherapists utilize modalities such as ultrasound therapy, taping techniques, and proprioceptive training to reduce pain and improve function without the need for invasive procedures.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Therapeutic Exercises and Stretches</h1>
                    <p>Therapeutic exercises and stretches are vital components of physiotherapy for Morton's Neuroma. Our therapists guide patients through targeted exercises designed to strengthen the foot, improve flexibility, and reduce pressure on the affected nerve. These exercises are tailored to each patient's condition and abilities.</p>
                    <br></br>
                    <ul>
                        <li>Toe curls and spreads</li>
                        <li>Ball rolling under the foot</li>
                        <li>Ankle pumps and circles</li>
                        <li>Calf stretches</li>
                        <li>Plantar fascia stretches</li>
                        <li>Metatarsal mobilization</li>
                        <li>Balance and proprioceptive exercises</li>
                        <li>Arch strengthening movements</li>
                        <li>Footwear advice and modifications</li>
                        <li>Activity modifications and pacing strategies</li>
                    </ul>
                </div>
            </div>
            </SkewedContainer>
            
    <SubpagesLink />
    <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default Physiotherapyformortonsneuroma;